export const PROJECT_CREATE = 'project_create'
export const PROJECT_UPDATE = 'project_update'
export const RENDER_START = 'render_start'
export const RENDER_COMPLETE = 'render_complete'
export const MEDIA_IMPORT_COMPLETE = 'media_import_complete'
